import { render, staticRenderFns } from "./ProductLinksTab.vue?vue&type=template&id=c24f4ad0&scoped=true&"
import script from "./ProductLinksTab.vue?vue&type=script&lang=js&"
export * from "./ProductLinksTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24f4ad0",
  null
  
)

export default component.exports